import { forwardRef, type Ref, type SVGProps } from "react";
const IconNoteFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M26 25v1a2.006 2.006 0 0 1-2 2H4a2.006 2.006 0 0 1-2-2v-5.29a12.4 12.4 0 0 0 2 2.24c.35.29.68.55 1 .77a11 11 0 0 0 1.89 1.07A3 3 0 0 0 8 25Z"
    />
    <path
      fill="currentColor"
      d="M29.61 21.2A10.5 10.5 0 0 1 26 13V6a2.006 2.006 0 0 0-2-2H4a2.006 2.006 0 0 0-2 2v8a9.54 9.54 0 0 0 2 6.06 10 10 0 0 0 1 1.09 9.4 9.4 0 0 0 2.63 1.78A1 1 0 0 0 8 23h21a1.003 1.003 0 0 0 .61-1.8M6 13a1.003 1.003 0 0 1 1-1h13a1 1 0 0 1 0 2H7a1.003 1.003 0 0 1-1-1m10-4a1.003 1.003 0 0 1-1 1H7a1 1 0 0 1 0-2h8a1.003 1.003 0 0 1 1 1"
    />
  </svg>
);
const ForwardRef = forwardRef(IconNoteFilledSVG);
ForwardRef.displayName = "IconNoteFilled";
export { ForwardRef as IconNoteFilled };
